import type { AppRouteConfig } from '../../models'

import { FeatureIdEnum, FilterIdEnum } from '../../enums'

import { BlacklistForm, BlacklistList } from '../../views'

import { ROUTER_CONSTS } from '../router.consts'
import { ENABLED_FILTER_CONFIG } from '../routes.filters'
import { ROUTES_PATHS } from '../routes.paths'

const BLACKLIST_PATHS = Object.assign(ROUTES_PATHS, {
  blacklist: 'blacklist',
})

export const BLACKLIST_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.BLACKLIST].list,
    path: BLACKLIST_PATHS.blacklist,
    component: BlacklistList,
    meta: {
      featureId: FeatureIdEnum.BLACKLIST,
      filters: () => ({
        config: {
          [FilterIdEnum.LANG]: {
            enabled: true,
          },
        },
        extra: {
          [ENABLED_FILTER_CONFIG.id]: ENABLED_FILTER_CONFIG,
        },
      }),
      style: {
        removeContentPadding: true,
      },
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.BLACKLIST].create,
    path: `${BLACKLIST_PATHS.blacklist}/${BLACKLIST_PATHS.actions.create}`,
    component: BlacklistForm,
    meta: {
      featureId: FeatureIdEnum.BLACKLIST,
      titleI18nKey: 'createBlacklist',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.BLACKLIST].list,
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.BLACKLIST].update,
    path: `${BLACKLIST_PATHS.blacklist}/${BLACKLIST_PATHS.actions.update}`,
    component: BlacklistForm,
    meta: {
      featureId: FeatureIdEnum.BLACKLIST,
      titleI18nKey: 'updateBlacklist',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.BLACKLIST].list,
    },
  },
]
